import { Controller, codeSplit, FetchOptions, StoreContainer } from 'bernie-core';
import { PageStore } from 'bernie-plugin-mobx';
import { ClientLogger } from 'bernie-client';
import { PageData, Request } from 'bernie-http';
import { logDetailedEvent } from 'logging/logger';
import { CRUISE_PROMOTIONS_CONTROLLER_INFO } from 'logging/log-events';

export class CruisePromotionsController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public path = '/cruise/promotions/termsAndConditions';

  public readonly routeName = 'cruisePromotions';
  public readonly component = codeSplit(() =>
    import(/* webpackChunkName: "cruise" */ '../views/cruise-promotions-view')
  );

  public readonly pageName = 'page.Promotions.termsAndConditions';
  public readonly pageId = `${this.pageName},CR,30`;

  public fetchPageData(): Promise<PageData> {
    const noIndexSeo = { seo: { robots: 'noindex, nofollow' } };

    return Promise.resolve({
      ...noIndexSeo,
      pageId: this.pageId,
      title: ''
    }) as Promise<PageData>;
  }

  public fetch(options: FetchOptions): Promise<any> {
    const { stores } = options;
    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    if (options.logger) {
      logDetailedEvent(options.logger, CRUISE_PROMOTIONS_CONTROLLER_INFO, {
        request: options.request,
        message: 'Request made to bex-api'
      });
    }

    return Promise.resolve({});
  }
  public shouldStreamResponse(request: Request, stores: StoreContainer): boolean {
    return true;
  }
}
